import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '@chilipiper/api-client/src/context'

export const usePublicPersonalitySettings = (tenantId: string, workspaceId: string) => {
  const { chatPlatformPiperAi } = useApiClient()

  return useQuery({
    queryKey: ['chat-piper-ai', 'personality-settings', tenantId, workspaceId],
    queryFn: () => {
      return chatPlatformPiperAi.getApiV1PublicTenantTenantidWorkspacesWorkspaceidPiperAiPersonalitySettings(
        tenantId,
        workspaceId
      )
    },
  })
}
